import type {ILogin, IYarismaciBaslangicBitis, LoginMethod} from "./yarismaci";

export interface ILoginDTO {
  m?: LoginMethod;
  ci: string;
  si: number;
  ct: Date;
  t?: string;
  e?: string;
  dg?: string;
  da?: string;
  dy?: string;
  c?: string;
  tc?: string;
}

export function mapLoginToDTO(login: ILogin): ILoginDTO {
  return {
    m: login.method,
    ci: login.client_id,
    si: login.session_id,
    ct: login.client_time,
    t: login.phone,
    e: login.email,
    dg: login.dogum_gun,
    da: login.dogum_ay,
    dy: login.dogum_yil,
    c: login.code,
    tc: login.tc,
  };
}

export interface IYarismaciBaslangicBitisDTO {
  ct: Date;
}


export function mapYarismaciBaslangicBitisToDTO(baslangicBitis: IYarismaciBaslangicBitis): IYarismaciBaslangicBitisDTO {
  return {
    ct: baslangicBitis.client_time,
  };
}
